import { HeartPulse, Stethoscope } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const workspaces = [
  { to: "/meu-espaco", label: "Meu Espaço", icon: HeartPulse, personal: true },
  { to: "/", label: "Clínica", icon: Stethoscope, personal: false },
] as const;

export function WorkspaceSwitch({ compact = false }: { compact?: boolean }) {
  const { pathname } = useLocation();
  const personalActive = pathname.startsWith("/meu-espaco");

  return (
    <div
      className={cn(
        "grid grid-cols-2 rounded-xl border bg-muted/40 p-1",
        compact ? "w-[164px]" : "w-full",
      )}
      aria-label="Alternar espaço do ClinicalOS"
    >
      {workspaces.map((workspace) => {
        const active = workspace.personal ? personalActive : !personalActive;
        return (
          <NavLink
            key={workspace.to}
            to={workspace.to}
            className={cn(
              "flex min-h-9 items-center justify-center gap-1.5 rounded-lg px-2 text-xs font-medium transition-colors",
              active
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <workspace.icon className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{workspace.label}</span>
          </NavLink>
        );
      })}
    </div>
  );
}
